export const habaMyAccountOrderHistory = {
  myOrderHistory: {
    empty : {
      filter: '',
      noOrder : ''
    },
    headline : 'Meine Bestellübersicht',
    filter: {
      orderNumber: 'Auftragsnummer',
      '3months': '3 Monate',
      '6months': '6 Monate',
      '12months': '12 Monate'
    },
    orderItem: {
      headline: {
        prefix: 'Bestellung vom'
      },
      details: {
        orderNumber: 'Auftragsnummer',
        orderValue: 'Bestellwert',
        status: 'Status'
      },
      button: 'Bestelldetails anzeigen'
    },
    return : {
      headline: 'Sie möchten eine Sendung an uns zurückschicken?',
      btnText : 'Auftrag retournieren'
    }
  },
  orderHistoryDetails: {
    error: 'Entschuldigung, da ist etwas schiefgelaufen.',
    notFound: 'Entschuldigung, für diese Nummern konnte kein Auftrag gefunden werden.',
    loading: 'Die Anfrage kann einige Sekunden dauern, bitte haben Sie etwas Geduld.',
    backLink : 'Zurück zur Bestellübersicht',
    downloadInvoice: 'Rechnung Herunterladen',
    headline : {
      prefix: 'Bestellung',
      canceled: 'Stornierte Artikel',
      shipment: 'Sendung {{ currentShipment }} von {{ allShipment }}'
    },
    info : {
      headline : {
        shipmentTracking: 'Sendungsverfolgung',
        status: 'Status',
        orderDate : 'Bestelldatum',
        shippingMethod : 'Versandart',
        orderTotal : 'Gesamtsumme',
        deliveryAddress : 'Lieferadresse',
        paymentAddress : 'Rechnungsadresse',
        paymentMethod : 'Zahlungsart',
        shipmentCount: 'Anzahl Sendungen',
        deliveryDate: 'Vorauss. Lieferung',
        date: 'Datum'
      }
    },
    entries : {
      articlePrefix : 'Artikel',
      singlePrice : 'Einzelpreis',
      totalPrice : 'Gesamt',
      articleNumber: 'Artikelnummer: {{code}}',
      amount: 'Menge: {{quantity}}',
      quantity: 'Menge',
      btnShowMore : 'Details einblenden',
      canceled : 'Storniert',
      noDeliveryDate: 'Datum wird ermittelt',
      noTrackingId: 'Sendungsverfolgung in Bearbeitung',
      componentsHeader: 'Diese Position besteht aus folgenden Artikeln:'
    },
    totals : {
      netValue : 'Warenwert Netto',
      goodValueTotal : 'Netto-Gesamt',
      deliveryCosts : 'Versandkosten Brutto',
      freightCosts : 'Frachtkosten Brutto',
      total: 'Gesamtsumme',
      vatIncluded: 'gesetzliche MwSt.',
      includedDiscount: 'enthaltener Rabatt',
      addedDiscountCodes: 'Rabattcodes hinzugefügt'
    },
    return : {
      headline: 'Sie möchten eine Sendung an uns zurückschicken?',
      btnText : 'Auftrag retournieren'
    },
    giftcards: 'Gutscheineinlösung'
  }
};
